document.addEventListener('DOMContentLoaded', function () {
  initTeckouPersonnalisation();
});

document.addEventListener('shopify:section:load', function () {
  initTeckouPersonnalisation();
});

function initTeckouPersonnalisation() {
  document
    .querySelectorAll('[data-teckou-personnalisation]')
    .forEach(function (root) {

      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';


      /* =========================
         COMPTEUR DE CARACTÈRES
         ========================= */

      const textInput = root.querySelector(
        'input[name="properties[Votre inscription]"]'
      );

      const characterCount = root.querySelector(
        '[data-teckou-character-count]'
      );

      if (textInput && characterCount) {
        function updateCounter() {
          characterCount.textContent = textInput.value.length;
        }

        updateCounter();
        textInput.addEventListener('input', updateCounter);
      }


      /* =========================
         PHOTO / LOGO
         ========================= */

      const specialYes = root.querySelector(
        '[data-teckou-special="yes"]'
      );

      const specialNo = root.querySelector(
        '[data-teckou-special="no"]'
      );

      const uploadWrapper = root.querySelector(
        '[data-teckou-upload]'
      );

      const fileInput = root.querySelector(
        '[data-teckou-file]'
      );

      const previewWrapper = root.querySelector(
        '[data-teckou-file-preview]'
      );

      const previewImage = root.querySelector(
        '[data-teckou-preview-image]'
      );

      const fileName = root.querySelector(
        '[data-teckou-file-name]'
      );


      function showUpload() {
        if (!uploadWrapper) return;

        uploadWrapper.removeAttribute('hidden');
        uploadWrapper.style.display = 'block';
      }


      function hideUpload() {
        if (!uploadWrapper) return;

        uploadWrapper.setAttribute('hidden', '');
        uploadWrapper.style.display = 'none';

        if (fileInput) {
          fileInput.value = '';
        }

        if (previewWrapper) {
          previewWrapper.setAttribute('hidden', '');
          previewWrapper.style.display = 'none';
        }

        if (previewImage) {
          previewImage.removeAttribute('src');
        }

        if (fileName) {
          fileName.textContent = '';
        }
      }


      if (specialYes) {
        specialYes.addEventListener('change', function () {
          if (specialYes.checked) {
            showUpload();
          }
        });
      }


      if (specialNo) {
        specialNo.addEventListener('change', function () {
          if (specialNo.checked) {
            hideUpload();
          }
        });
      }


      /* État initial */

      if (specialYes && specialYes.checked) {
        showUpload();
      } else {
        if (uploadWrapper) {
          uploadWrapper.setAttribute('hidden', '');
          uploadWrapper.style.display = 'none';
        }
      }


      /* =========================
         FICHIER
         ========================= */

      if (fileInput) {
        fileInput.addEventListener('change', function () {

          const file = fileInput.files
            ? fileInput.files[0]
            : null;

          if (!file) {
            if (previewWrapper) {
              previewWrapper.setAttribute('hidden', '');
              previewWrapper.style.display = 'none';
            }
            return;
          }


          /* JPG / JPEG / PNG uniquement */

          const allowedTypes = [
            'image/jpeg',
            'image/png'
          ];

          if (!allowedTypes.includes(file.type)) {
            alert('Merci de sélectionner un fichier JPG, JPEG ou PNG.');

            fileInput.value = '';

            if (previewWrapper) {
              previewWrapper.setAttribute('hidden', '');
              previewWrapper.style.display = 'none';
            }

            return;
          }


          /* Taille maximale : 10 Mo */

          const maxFileSize = 10 * 1024 * 1024;

          if (file.size > maxFileSize) {
            alert('Le fichier ne doit pas dépasser 10 Mo.');

            fileInput.value = '';

            if (previewWrapper) {
              previewWrapper.setAttribute('hidden', '');
              previewWrapper.style.display = 'none';
            }

            return;
          }


          /* Nom du fichier */

          if (fileName) {
            fileName.textContent = file.name;
          }


          /* Aperçu */

          if (previewImage && previewWrapper) {
            const reader = new FileReader();

            reader.onload = function (event) {
              previewImage.src = event.target.result;

              previewWrapper.removeAttribute('hidden');
              previewWrapper.style.display = 'flex';
            };

            reader.readAsDataURL(file);
          }

        });
      }

    });
}